var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4922_1888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13493 0C7.15244 0.0603377 7.20935 0.025859 7.24875 0.0387885C7.49829 0.124985 7.68653 0.370646 7.69966 0.642165C7.70842 0.866277 7.70842 1.0947 7.70404 1.31881C7.70404 1.40501 7.73031 1.43948 7.81786 1.45241C9.86226 1.81013 11.3988 3.27978 11.8191 5.28817C11.8892 5.61571 11.9023 5.94757 11.9067 6.28374C11.911 7.01641 11.8716 7.74908 11.9286 8.48175C12.0249 9.71437 12.5458 10.7444 13.4783 11.5676C13.7497 11.8089 13.9686 12.0762 13.9992 12.4511C14.0605 13.1795 13.5483 13.7484 12.8085 13.7872C12.7691 13.7872 12.7341 13.7872 12.6947 13.7872C8.90354 13.7872 5.11242 13.7872 1.3213 13.7872C0.809104 13.7872 0.406352 13.5932 0.152444 13.1493C-0.136487 12.6407 -0.00953251 12.0417 0.467641 11.6366C0.931681 11.24 1.30379 10.7746 1.58834 10.2402C1.94732 9.55921 2.10929 8.83085 2.10929 8.0637C2.10929 7.39568 2.10054 6.72765 2.11367 6.05963C2.15745 3.79696 3.90854 1.81875 6.18059 1.45672C6.28565 1.43948 6.3163 1.40501 6.31192 1.30157C6.30316 1.10763 6.30754 0.913685 6.31192 0.719742C6.3163 0.366336 6.46952 0.155154 6.81536 0.0301688C6.82849 0.025859 6.83725 0.00861967 6.846 0C6.93793 0 7.03862 0 7.13493 0Z",
    fill: "#744FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61008 16.5449C6.39995 16.4501 6.16793 16.4242 5.95342 16.3294C5.1698 15.9717 4.67512 15.3812 4.44748 14.5667C4.43872 14.5408 4.4431 14.5149 4.43872 14.4805C6.14604 14.4805 7.85336 14.4805 9.56943 14.4805C9.47312 14.9373 9.26736 15.3381 8.95654 15.6786C8.52753 16.1441 7.99782 16.4328 7.35867 16.5147C7.34554 16.5147 7.33678 16.5319 7.32803 16.5449C7.09163 16.5449 6.85085 16.5449 6.61008 16.5449Z",
    fill: "#744FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4922_1888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16.5455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActive);
export default __webpack_public_path__ + "static/media/notificationActive.a06929c03c24e5c5f1e1100e4fa8dd5e.svg";
export { ForwardRef as ReactComponent };